<div class="mtp-container" [class.mtp-container--preview]="previewMode">

  <!--<div class="mtp-header">
    <span class="mtp-title">Fields</span>
    <small class="mtp-hint">Click to add</small>-->
    <!--<button pButton icon="pi pi-pencil" label="Add Text" class="p-button-outlined p-button-sm mtp-btn-add-text"
            pTooltip="Add a free-text label to the canvas" tooltipPosition="right"
            (click)="addFreeText.emit()">
    </button>-->
  <!--</div>-->

  <div class="mtp-groups" style="max-height:100px;">
    <div class="mtp-group">

      <!-- Group Header -->
      <div class="mtp-group__header">
        <span class="mtp-group__name">{{ 'bikeshop.receipt_template.panel.custom_group' | translate }}</span>
       
      </div>

      <!-- Tags -->
      <div class="mtp-group__tags">
        <div class="mtp-tag" (click)="addFreeText.emit()">
          <i class="pi mtp-tag__icon pi-text"></i>
          <span class="mtp-tag__label">{{ 'bikeshop.receipt_template.panel.free_text' | translate }}</span>
        </div>
        <div class="mtp-tag" (click)="addDivider.emit()">
          <i class="pi mtp-tag__icon pi-minus"></i>
          <span class="mtp-tag__label">{{ 'bikeshop.receipt_template.panel.line' | translate }}</span>
        </div>
      </div>

    </div>
  </div>

  <!-- Header -->
  <div class="mtp-header">
    <span class="mtp-title">{{ 'bikeshop.message_templates.available_merge_tags' | translate}}</span>
    <small class="mtp-hint">{{ 'bikeshop.receipt_template.panel.click_to_add' | translate }}</small>
  </div>

  <!-- Search -->
  <div class="mtp-search">
    <span class="p-input-icon-left mtp-search__wrap">
      <i class="pi pi-search"></i>
      <!--<input type="text" pInputText placeholder="Search fields…"
             [(ngModel)]="searchText" (ngModelChange)="applyFilter()" />-->
      <hub-input [label]="'bikeshop.receipt_template.panel.search_placeholder' | translate" [(ngModel)]="searchText" (ngModelChange)="applyFilter()"
                 [iconColor]="'#888888'"
                [icon]="'search'" [autofocus]="true"
                [allowClear]="true"
                 ></hub-input>
    </span>
  </div>

  <!-- Groups -->
  <div class="mtp-groups">
    <div class="mtp-group" *ngFor="let group of filteredGroups">

      <!-- Group Header -->
      <div class="mtp-group__header" (click)="toggleGroup(group)">
        <span class="mtp-group__name">{{ group.name }}</span>
        <i class="pi" [class.pi-chevron-down]="group.expanded" [class.pi-chevron-right]="!group.expanded"></i>
      </div>

      <!-- Tags -->
      <div class="mtp-group__tags" *ngIf="group.expanded">
        <div *ngFor="let tag of group.tags"
             class="mtp-tag"
             [class.mtp-tag--placed]="isPlaced(tag)"
             [attr.draggable]="isPlaced(tag) ? 'false' : 'true'"
             (dragstart)="onDragStart(tag, $event)"
             (click)="addTag(tag)">

          <i class="pi mtp-tag__icon" [ngClass]="'pi-' + getElementTypeIcon(tag)"></i>
          <span class="mtp-tag__label">{{ tag.label }}</span>
          <i class="pi pi-check mtp-tag__placed-icon" *ngIf="isPlaced(tag)"></i>
        </div>
      </div>

    </div>
  </div>

</div>
